import classes from "./QuickDetails.module.css";
import Svg1 from "./Svg1/Svg1";
import Svg2 from "./Svg2/Svg2";
import Svg3 from "./Svg3/Svg3";

export const QuickDetails = ({ quickDetailsViewModel }) => {
  const inclusion = quickDetailsViewModel.inclusions;

  const exclusion = quickDetailsViewModel.exclusions;

  const weather = quickDetailsViewModel.quickDetails[0].description;

  let duration = "";

  if (quickDetailsViewModel.quickDetails.length > 1) {
    duration = quickDetailsViewModel.quickDetails[1].description;
  }

  let impact = "";

  if (quickDetailsViewModel.quickDetails.length > 2) {
    impact = quickDetailsViewModel.quickDetails[2].description;
  }

  return (
    <>
      <div className={classes["quick-outer-container"]}>
        <p className={classes["quick-heading"]}>Quick Details</p>
        <div className={classes["images-container"]}>
          <div className={classes["svg-container"]}>
            <Svg1 />
            <p className={classes["svg-text-heading"]}>Weather</p>
            <p className={classes["svg-text-desc"]}>{weather}</p>
          </div>
          <div className={classes["svg-container"]}>
            <Svg2 />
            <p className={classes["svg-text-heading"]}>Duration</p>
            <p className={classes["svg-text-desc"]}>{duration}</p>
          </div>
          <div className={classes["svg-container"]}>
            <Svg3 />
            <p className={classes["svg-text-heading"]}>Impact</p>
            <p className={classes["svg-text-desc"]}>{impact}</p>
          </div>
        </div>
        <div className={classes["inc-exclusion-container"]}>
          <div className={classes["inclusion"]}>
            <p className={classes["inc-heading"]}>Inclusion</p>
            {inclusion &&
              inclusion.map((inc, index) => {
                return (
                  <div key={index} style={{ display: "flex", flexDirection: "row" }}>
                    <p className={classes["inc-points"]}>
                      {index + 1}.&nbsp;&nbsp;
                    </p>
                    <p className={classes["inc-points"]}>{inc}</p>
                  </div>
                );
              })}
          </div>
          <div className={classes["exclusion"]}>
            <p className={classes["inc-heading"]}>Exclusion</p>
            {exclusion &&
              exclusion.map((exc, index) => {
                return (
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <p className={classes["inc-points"]}>
                      {index + 1}.&nbsp;&nbsp;
                    </p>
                    <p className={classes["inc-points"]}>{exc}</p>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};
